export default {"src":"/_next/static/media/phone-option.feaf4ba1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};